export default __webpack_public_path__ + "static/media/Mandu.703415c0.jpg";